import React from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiTrustTransferEUR } from "../lib/api";

export default function TrustTransfer() {
  const nav = useNavigate();
  const [amount, setAmount] = React.useState("");
  const [err, setErr] = React.useState<string | null>(null);
  const [ready, setReady] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let alive = true;
    apiGet<any>("/xapi/me")
      .then((res) => {
        if (!alive) return;
        if (res?.modules?.trust?.enabled === false) {
          setErr("Trust services are not available for this tenant.");
          return;
        }

        const status = String(res?.trust?.status ?? "").toLowerCase();
        if (!["active", "approved"].includes(status)) {
          setErr("Please apply for trust first. A transfer to trust requires an approved trust.");
          return;
        }

        setReady(true);
      })
      .catch(() => {
        if (alive) setErr("Could not verify trust status.");
      });

    return () => {
      alive = false;
    };
  }, []);

  const onSubmit = async () => {
    setErr(null);
    const v = Number(amount || 0);
    if (!ready) return setErr("Please apply for trust first. A transfer to trust requires an approved trust.");
    if (!v || v <= 0) return setErr("Enter a valid amount");
    setLoading(true);
    try {
      const r = await apiTrustTransferEUR({ amount: v });
      if (!r?.ok) throw new Error(r?.error || "Failed");
      nav("/transfers");
    } catch (e:any) {
      setErr(e?.message || "Could not transfer");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section-box max-w-sm mx-auto p-4 sm:p-6">
      <h1 className="text-xl font-semibold mb-3">Transfer to Trust (EUR)</h1>
      {err && <div className="alert-danger mb-3">{err}</div>}
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Amount (EUR)</label>
          <input
            className={[
              "input w-full",
              "rounded-xl border border-gray-300 px-3 py-2",
              "focus:outline-none focus:ring-2 focus:ring-blue-500",
            ].join(" ")}
            value={amount}
            onChange={e => setAmount(e.target.value)}
            placeholder="0.00"
          />
        </div>
        <div className="flex gap-2">
          <button className="btn btn-success" onClick={onSubmit} disabled={loading || !ready}>Transfer</button>
        </div>
      </div>
    </div>
  );
}
